"use client";

import { SubscribeBox, SocialLinks, Advertisement } from "./components";

export default function Sidebar() {
  return (
    <div className="lg:col-span-1">
      <div className="sticky top-6 lg:top-8 space-y-6">
        {/* Subscribe Section */}
        <SubscribeBox />

        {/* Social Stream */}
        <SocialLinks />

        {/* Advertisement Placeholder */}
        <Advertisement />
      </div>
    </div>
  );
}
